export default __webpack_public_path__ + "static/media/tupay-channels.218d9b70.png";